import styled from 'styled-components';

export default styled.div`
  width: 100%;
  display: block;
  position: relative;
  margin-bottom: 1.4rem;
  height: 0.6rem;
  background: #999;
  border-radius: 0.3rem;
  cursor: pointer;
`;
